import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import IconButton from "@mui/material/IconButton";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, TextField, Checkbox, FormControlLabel, Link, Button, Input } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AuthBoxHeader from "../../components/authentication/AuthBoxHeader";
import { Form, FormikProvider, useFormik } from "formik";
import authStores from "../../contexts/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, LoadScript } from "@react-google-maps/api";
// import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import GoogleIcon from "src/svgComponents/GoogleIcon";
import PhoneInput from "react-phone-input-2";
import AuthRegisterLayour from "src/layouts/AuthRegisterPageLayout";

const Register = () => {
  const authStore = authStores();
  const navigate = useNavigate();
  // const axiosPrivate = useAxiosPrivate();
  const { enqueueSnackbar } = useSnackbar();
  const [category, setCategory] = useState();
  // const [subcategory, setSubCategory] = useState([]);
  // const [getSubCategoryData, setSubCategoryData] = useState([]);
  const [loading, setLoding] = useState(false);
  const [locationLat, setLocationLat] = useState();
  const [locationLng, setLocationLng] = useState();
  const [address, setAddress] = useState();
  const [phoneValue, setPhoneValue] = useState();
  const [postCode, setPostCode] = useState();
  const [terms, setTerms] = useState(false);
  const [disabled, setDisable] = useState(false);
  const googleMapKey = process.env.REACT_APP_GOOGLE_KEY;

  const [passwordInput, setPasswordInput] = useState({
    password: "",
    showPassword: false,
  });

  // async function getSubCategories() {
  //   const response = await axiosPrivate.get(AUTH_API_URL.getSubCategory, { params: { category_type: category } });
  //   setSubCategoryData(response.data.subcategories);
  //   return response.data.subcategories;
  // }

  // useEffect(() => {
  //   if (category !== undefined) {
  //     getSubCategories();
  //   }
  // }, [category]);

  // Password Input Functionality
  const handleChange = (prop) => (event) => {
    setPasswordInput({ ...passwordInput, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setPasswordInput({
      ...passwordInput,
      showPassword: !passwordInput.showPassword,
    });
  };

  const handleClickShowConfirmPassword = () => {
    setPasswordInput({
      ...passwordInput,
      showConfirmPassword: !passwordInput.showConfirmPassword,
    });
  };
  const handlechangeterm = () => {
    if (terms == false) {
      setTerms(true);
      setDisable(false);
    } else {
      setTerms(false);
      setDisable(true);
    }
  }

  const LoginByMailSchema = Yup.object().shape({
    name: Yup.string()
      .max(255, "You can not enter more than 255 characters!")
      .required("Name is required"),
    businessName: Yup.string().max(255, "You can not enter more than 255 characters!").required("Business name is required"),
    businessPhone: Yup.string().min(8, "Business phone must be 8-15 digit!").max(15, "Business phone must be 8-15 digit!").required("Business phone is required"),
    businessEmail: Yup.string().email("business email must be a valid email address").required("Business email is required"),
    businessAddress: Yup.string().required("Business Address is required"),
    email: Yup.string().email("email must be a valid email address").required("email is required"),
    password: Yup.string().required("Password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], "Confirm password must match with password")
      .required("Confirm Password is required"),
    postal_code: Yup.string().required("postal code is required")
      // .min(3,"Postal code must be 3 to 6 digit")
      .max(10, "Postal code must be 10 digit/character")
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      businessName: "",
      businessAddress: "",
      businessPhone: "",
      businessEmail: "",
      category_type: "",
      password: "",
      longitude: "",
      latitude: "",
      remember: true,
      postal_code: "",
    },
    validationSchema: LoginByMailSchema,
    onSubmit: async (values, { resetForm }) => {
      if (terms == false) {
        setDisable(true)
        enqueueSnackbar("Please accept our terms & conditions", {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else if (address == undefined) {
        enqueueSnackbar("Please enter business address", {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        const loginObj = {
          name: values.name,
          email: values.email,
          businessName: values.businessName,
          businessAddress: address,
          businessPhone: phoneValue,
          businessEmail: values.businessEmail,
          category_type: category,
          // subCategories: subcategory,
          password: values.password,
          longitude: locationLng,
          latitude: locationLat,
          postal_code: postCode,
          device: 3,
          pushToken: "test",
        };
        setLoding(true);
        const [success, error] = await authStore.register(loginObj);
        const userData = {
          userEmail: values.email,
        };
        if (success) {
          enqueueSnackbar("Register Successfully. Verification Email is sended on registered email, please varify it before login. Thank you!", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
          navigate("/otp-verification", { state: userData });
          setLoding(false);
        } else {
          setLoding(false);
          if (error.name) {
            setFieldError("name", error.name);
          }
          if (error.email) {
            setFieldError("email", error.email);
          }
          if (error.password) {
            setFieldError("password", error.password);
          }
          if (error.kycImage) {
            setFieldError("kycImage", error.kycImage);
          }
          if (error.businessName) {
            setFieldError("businessName", error.businessName);
          }
          if (error.businessPhone) {
            setFieldError("businessPhone", error.businessPhone);
          }
          if (error.businessEmail) {
            setFieldError("businessEmail", error.businessEmail);
          }
          if (error.postal_code) {
            setFieldError("postal_code", error.postal_code);
          }
          if (error.category_type) {
            enqueueSnackbar(error.category_type, {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "right" },
              autoHideDuration: 2000,
            });
          }
        }
      }
    },
  });

  const { errors, touched, handleSubmit, getFieldProps, setFieldError, setFieldValue } = formik;

  const [autoComplete, setAutoComplete] = useState();

  const onAutoCompleteIsLoad = (inputAutoComplete) => {
    setAutoComplete(inputAutoComplete);
  };
  const onAutoCompletePlaceIsChanged = () => {
    // console.log("auto complete is changed: ", autoComplete.getPlace());
    if (autoComplete !== null) {
      var place = autoComplete.getPlace();
      setAddress(place.formatted_address);
      setFieldValue("businessAddress", place.formatted_address);
      setLocationLat(place.geometry.location.lat());
      setLocationLng(place.geometry.location.lng());

      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types;
        addressType.map((type) => {
          if (type === "postal_code") {
            setPostCode(place.address_components[i].long_name);
            setFieldValue("postal_code", place.address_components[i].long_name)
          }
        })
      }
    }
  };

  const handlePhoneValue = (e) => {
    setPhoneValue(e);
    setFieldValue("businessPhone", e);
  };
  const handlePostCode = (e) => {
    setPostCode(e.target.value);
    setFieldValue("postal_code", e.target.value);
  };

  const label_ = (
    <div>
      <span>I accept the </span>
      <Link to="#">Terms & Conditions</Link>
    </div>
  )

  return (
    <>
      <AuthRegisterLayour>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <div className="auth_box">
              <AuthBoxHeader title={"Register Welcome"} />
              <Stack spacing={3}>
                <FormControl className="form-control-custom" sx={{marginTop: "0px", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": { position: "unset", transform: "unset", fontSize: "14px", fontWeight: "500", color: "#333230", marginBottom: "6px"}}}>
                  <InputLabel htmlFor="my-input">Name</InputLabel>
                  <TextField id="inputName" sx={{
                    "&.MuiTextField-root": {
                      margin: "0px !Important",
                      "& .MuiFormHelperText-root": {
                        marginLeft: "0px !important",
                        marginRight: "0px !important"
                      },
                      "& .MuiInputBase-root": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        "&.Mui-error": {
                          border: "1px solid #d32f2f",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px",
                          background: "none",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: "500"
                        },
                      }
                    },
                  }}
                    InputLabelProps={{ shrink: true }}
                    hiddenLabel variant="outlined"
                    type="text" autoComplete="off"
                    fullWidth {...getFieldProps("name")}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                    placeholder="Enter name"
                  />
                </FormControl>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset", transform: "unset", fontSize: "14px", fontWeight: "500", color: "#333230", marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Email</InputLabel>
                  <TextField id="inputEmail" sx={{
                    "&.MuiTextField-root": {
                      margin: "0px !Important",
                      "& .MuiFormHelperText-root": {
                        marginLeft: "0px !important",
                        marginRight: "0px !important"
                      },
                      "& .MuiInputBase-root": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        "&.Mui-error": {
                          border: "1px solid #d32f2f",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px",
                          background: "none",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: "500"
                        },
                      }
                    },
                  }}
                    type="email" autoComplete="off"
                    fullWidth variant="outlined"
                    hiddenLabel
                    {...getFieldProps("email")}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                    placeholder="Enter email"
                  />
                </FormControl>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset", transform: "unset", fontSize: "14px", fontWeight: "500", color: "#333230", marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Business Email</InputLabel>
                  <TextField
                    id="businessEmail"
                    hiddenLabel
                    type="email"
                    autoComplete="off"
                    fullWidth
                    sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}
                    variant="outlined"
                    margin="normal"
                    {...getFieldProps("businessEmail")}
                    error={Boolean(touched.businessEmail && errors.businessEmail)}
                    helperText={touched.businessEmail && errors.businessEmail}
                    placeholder="Enter business email"
                  />
                </FormControl>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "& + div": {
                    display: "none",
                    "& + div": {
                      marginTop: "0px !important"
                    }
                  }, "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Business Name</InputLabel>
                  <TextField id="businessName" sx={{
                    "&.MuiTextField-root": {
                      margin: "0px !Important",
                      "& .MuiFormHelperText-root": {
                        marginLeft: "0px !important",
                        marginRight: "0px !important"
                      },
                      "& .MuiInputBase-root": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        "&.Mui-error": {
                          border: "1px solid #d32f2f",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px",
                          background: "none",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: "500"
                        },
                      }
                    },
                  }}
                    type="text"
                    hiddenLabel
                    autoComplete="off"
                    fullWidth variant="outlined"
                    {...getFieldProps("businessName")}
                    error={Boolean(touched.businessName && errors.businessName)}
                    helperText={touched.businessName && errors.businessName}
                    placeholder="Enter business name"
                  />
                </FormControl>
                <LoadScript googleMapsApiKey={googleMapKey} libraries={["drawing", "places"]}>
                  <Autocomplete onLoad={onAutoCompleteIsLoad} onPlaceChanged={onAutoCompletePlaceIsChanged}>
                    <FormControl className="form-control-custom" sx={{
                      marginTop: "0px !important", marginBottom: "14px !important", width: "100% !important", "&.form-control-custom .MuiFormLabel-root": {
                        position: "unset",
                        transform: "unset",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333230",
                        marginBottom: "6px",
                      }
                    }}>
                      <InputLabel htmlFor="my-input">Business Address</InputLabel>
                      <TextField
                        sx={{
                          "&.MuiTextField-root": {
                            margin: "0px !Important",
                            "& .MuiFormHelperText-root": {
                              marginLeft: "0px !important",
                              marginRight: "0px !important"
                            },
                            "& .MuiInputBase-root": {
                              padding: "14px 24px",
                              border: "1px solid #BDBDBD",
                              borderRadius: "8px",
                              backgroundColor: "#ffffff",
                              "&.Mui-error": {
                                border: "1px solid #d32f2f",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .MuiInputBase-input": {
                                padding: "0px",
                                background: "none",
                                borderRadius: "0px",
                                fontSize: "14px",
                                fontWeight: "500"
                              },
                            }
                          },
                        }}
                        hiddenLabel
                        type="text"
                        autoComplete="off"
                        fullWidth
                        variant="outlined"
                        placeholder="Search business address"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <GoogleIcon size={36} />
                            </InputAdornment>
                          ),
                        }}
                        error={Boolean(touched.businessAddress && errors.businessAddress)}
                        helperText={touched.businessAddress && errors.businessAddress}
                      />
                    </FormControl>
                  </Autocomplete>
                </LoadScript>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Postal Code</InputLabel>
                  <TextField
                    id="postal_code"
                    label=""
                    hiddenLabel
                    type="text"
                    sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    {...getFieldProps("postal_code")}
                    onChange={(e) => handlePostCode(e)}
                    error={Boolean(touched.postal_code && errors.postal_code)}
                    helperText={touched.postal_code && errors.postal_code}
                    placeholder="Enter postal code"
                  />
                </FormControl>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Business Phone</InputLabel>
                  <PhoneInput
                    specialLabel=""
                    country={"india"}
                    value={phoneValue}
                    className="react-tel-input-white"
                    onChange={(phone) => handlePhoneValue(phone)}
                    renderInput={(props) => <TextField {...props} autoComplete="off" fullWidth variant="outlined" name="businessPhone" {...getFieldProps("businessPhone")} />}
                  />
                  {errors.businessPhone && touched.businessPhone && <FormHelperText error>{errors.businessPhone}</FormHelperText>}
                  {/* <TextField
                    id="postal_code"
                    label=""
                    hiddenLabel
                    type="text"
                    sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    {...getFieldProps("postal_code")}
                    onChange={(e) => handlePostCode(e)}
                    error={Boolean(touched.postal_code && errors.postal_code)}
                    helperText={touched.postal_code && errors.postal_code}
                  /> */}
                </FormControl>


                <FormControl fullWidth className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel id="">Category</InputLabel>
                  <Select labelId="demo-simple-select-label" sx={{
                    "&.MuiInputBase-root": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "& .MuiSelect-select": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                      }
                    }
                  }} id="category_type" defaultValue={category} hiddenLabel onChange={(e) => setCategory(e.target.value)}>
                    <MenuItem value={1}>Restaurant</MenuItem>
                    <MenuItem value={2}>Grocery</MenuItem>
                    <MenuItem value={3}>Event</MenuItem>
                    {/* <MenuItem value={4}>Travel</MenuItem> */}
                    <MenuItem value={5}>Ngo</MenuItem>
                  </Select>
                </FormControl>
                {/* {category === 1 || category === 2 ? <FormControl fullWidth>
                           <InputLabel id="demo-simple-select-label"
                           >Sub-Category</InputLabel>
                           <Select
                              labelId="demo-simple-select-label"
                              id="sub_category_type"
                              defaultValue={subcategory}
                              label="Sub Category"
                              multiple={true}
                              onChange={(e) => setSubCategory(e.target.value)}

                           >
                              {getSubCategoryData && getSubCategoryData.map((data) =>
                                 <MenuItem value={data?._id}>
                                    {data ? data.name : "no data Found"}
                                 </MenuItem>)}
                           </Select>
                        </FormControl> : <></>} */}
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Password</InputLabel>
                  <TextField
                    id="outlined-adornment-password"
                    fullWidth
                    sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}
                    autoComplete="current-password"
                    type={passwordInput.showPassword ? "text" : "password"}
                    margin="normal"
                    hiddenLabel
                    value={passwordInput.password}
                    onChange={handleChange("password")}
                    {...getFieldProps("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={{ "&:hover": { bgcolor: "transparent" } }} disableRipple aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                            {passwordInput.showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    placeholder="Enter password"
                  />
                </FormControl>
                <FormControl className="form-control-custom" sx={{
                  marginTop: "0px !important", marginBottom: "14px !important", "&.form-control-custom .MuiFormLabel-root": {
                    position: "unset",
                    transform: "unset",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333230",
                    marginBottom: "6px"
                  }
                }}>
                  <InputLabel htmlFor="my-input">Confirm Password</InputLabel>
                  <TextField
                    id="outlined-adornment-password"
                    fullWidth
                    sx={{
                      "&.MuiTextField-root": {
                        margin: "0px !Important",
                        "& .MuiFormHelperText-root": {
                          marginLeft: "0px !important",
                          marginRight: "0px !important"
                        },
                        "& .MuiInputBase-root": {
                          padding: "14px 24px",
                          border: "1px solid #BDBDBD",
                          borderRadius: "8px",
                          backgroundColor: "#ffffff",
                          "&.Mui-error": {
                            border: "1px solid #d32f2f",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "0px",
                            background: "none",
                            borderRadius: "0px",
                            fontSize: "14px",
                            fontWeight: "500"
                          },
                        }
                      },
                    }}
                    autoComplete="current-password"
                    type={passwordInput.showConfirmPassword ? "text" : "password"}
                    hiddenLabel
                    margin="normal"
                    value={passwordInput.confirm_password}
                    onChange={handleChange("confirm_password")}
                    {...getFieldProps("confirm_password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={{ "&:hover": { bgcolor: "transparent" } }} disableRipple aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword} edge="end">
                            {passwordInput.showConfirmPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={Boolean(touched.confirm_password && errors.confirm_password)}
                    helperText={touched.confirm_password && errors.confirm_password}
                    placeholder="Enter confirm password"
                  />
                </FormControl>
                <div className="text-left">
                  <Checkbox
                    checked={terms}
                    label={label_}
                    onChange={handlechangeterm}
                  />
                  <a href="https://binoxbargains.com/terms-and-conditions.html" target="_blank">Accept Terms & Conditions</a> &
                  <a href="https://binoxbargains.com/privacy-policy" target="_blank"> Privacy Policy</a>
                </div>
              </Stack>
              <Button disabled={disabled} sx={{
                backgroundColor: "#FFBD05", boxShadow: "none", borderRadius: "8px", "&:hover": {
                  backgroundColor: "#FFBD05",
                  boxShadow: "none",
                }
              }} type="submit" className="mt-4 text-white app_text_16_semibold app_btn_lg" loading={loading} loadingPosition="end" variant="contained">
                Register
              </Button>
              &nbsp;
              <h6 className="text-center auth_last_comment">
                You have an account? <a href="/login">Login</a>.
              </h6>
            </div>
          </Form>
        </FormikProvider>
      </AuthRegisterLayour>
    </>
  );
};

export default Register;
